// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"c762e41f2aa3c2bc","5285":"961fc3c298e2a633"}[chunkId] + ".css";
};